"use strict"

function invert(hash) {
  var result = {}
  for(var i in hash) {
    if(hash.hasOwnProperty(i)) {
      result[hash[i]] = i
    }
  }
  return result
}

module.exports = invert


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/~/invert-hash/invert.js
 ** module id = 1052
 ** module chunks = 0
 **/